export const matchEndsAt = match => new Date(match.ends_at || new Date(new Date(match.date_time).getTime() + 3600000));
export const isMatchFinished = (match, now = new Date()) => match.status === 'completed' || matchEndsAt(match) <= now;
// "gio 15/10 alle 20:00" from a local 'YYYY-MM-DDTHH:MM' series date.
export const formatSeriesDate = (value) => {
  const d = new Date(value);
  const day = d.toLocaleDateString('it-IT', { weekday: 'short', day: '2-digit', month: '2-digit' });
  return `${day} alle ${value.slice(11, 16)}`;
};
export const isMatchUpcoming = (match, now = new Date()) => match.status !== 'cancelled' && !isMatchFinished(match, now);
